import React, { useState } from 'react'
import { Popup } from 'react-leaflet'
import {
    Grid,
    Typography,
    IconButton,
    FormControlLabel,
    Checkbox,

} from '@material-ui/core'
import WhatsAppIcon from '@material-ui/icons/WhatsApp'
import PhoneInTalkIcon from '@material-ui/icons/PhoneInTalk'
import { updateOrder } from '../../../firebase/obj/order'
import { formatUruguayPhoneNumber } from '../../../utils'
import useMainContext from '../../../hooks/useMainContext'
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')


export default function OrderMapPopup({ order, positionToObj, normalizeOrderAddress }) {
    const { isAdmin, getPaymentMethodName } = useMainContext()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    const handleUpdateOrder = async () => {
        try {
            if (order.orderState === 'Entregado')
                return

            setError(null)
            setLoading(true)
            const _order = { ...order, orderState: 'Entregado' }
            await updateOrder(_order)
        } catch (error) {
            setError(`Error al actualizar estado del pedido: ${error.message}`)
        }
        setTimeout(() => {
            setLoading(false)
        }, 2000)
    }

    return (
        <Popup position={positionToObj(order.position)}>
            <Grid container spacing={1} style={{ paddingTop: 10, minWidth: 270 }}>
                <Grid item xs={6} container justify="flex-start">
                    <Typography component="div" variant="body1">{`Cod: ${order.cod}`} </Typography>
                </Grid>
                <Grid item xs={6} container justify="flex-end" >
                    <Typography component="div" variant="body1" align='rigth'>{moment(new Date(order.date.seconds * 1000)).fromNow()} </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography component="div" variant="body2">{order.clientName} </Typography>
                    <Typography component="div" variant="body2">{order.pickup ? 'RETIRA EN EL LOCAL' : normalizeOrderAddress(order.address)} </Typography>
                </Grid>
                <Grid item xs={12} container justify="center" alignItems="center">
                    <Grid item xs={6}>
                        <a style={{ textDecoration: 'none', color: 'green', display: 'block', textAlign: 'center', alignItems: 'center' }} href={`https://api.whatsapp.com/send?phone=${formatUruguayPhoneNumber(order.clientPhone || order.phone)}&text=Hola,%20su%20pedido%20esta%20en%20camino`} target="_blank">
                            <IconButton style={{ color: 'green' }} aria-label="Whatsapp" >
                                <WhatsAppIcon />
                            </IconButton>
                            <Typography component="div" variant="body2" style={{ color: 'green' }}>Escribir</Typography>
                        </a>
                    </Grid>
                    <Grid item xs={6}>
                        <a style={{ textDecoration: 'none', display: 'block', textAlign: 'center', alignItems: 'center' }} href={`tel:${order.clientPhone || order.phone}`} >
                            <IconButton color="primary" aria-label="Llamar">
                                <PhoneInTalkIcon />
                            </IconButton>
                            <Typography component="div" variant="body2" color="primary" >Llamar</Typography>
                        </a>
                    </Grid>
                </Grid>

                {
                    isAdmin &&
                    <Grid item xs={12}>
                        <Typography >{order.deliveryName && `Repartidor: ${order.deliveryName}`}</Typography>
                    </Grid>
                }

                <Grid item xs={12}>
                    <Typography >Notas: {order.notes || ''}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography component="div" variant="body2">{getPaymentMethodName({ order })} </Typography>
                </Grid>
                <Grid item xs={12} style={{ margin: '10px 0 10px 0' }}>
                    <Typography component="div" variant="body1" style={{ fontWeight: 'bold' }}>{`Total: $${order.amount}`}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography component="div" variant="body2">
                        {(order.inLocationChecked && order.orderState !== 'Entregado') ? 'Estás cerca del lugar de entrega' : ''}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    {
                        loading ?
                            <Typography component="p" variant="body2" color="primary" >Guardando...</Typography>
                            :
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        disabled={order.orderState === 'Entregado'}
                                        checked={order.orderState === 'Entregado'}
                                        onChange={handleUpdateOrder}
                                        name="checkedEntregado"
                                        color="primary"
                                    />
                                }
                                label="Entregado"
                            />
                    }
                </Grid>
                {
                    order.orderState === 'Entregado' && order.delivered &&
                    <Grid item xs={12}>
                        <Typography component="div" variant="body2" >
                            Entregado el {moment(new Date(order.delivered?.seconds * 1000)).format('DD/MM/YYYY HH:mm')}
                        </Typography>
                    </Grid>
                }
                {
                    error && <Grid item xs={12} style={{ margin: '10px 0 10px 0' }}>
                        <Typography component="div" variant="body2" color="error" >{error}</Typography>
                    </Grid>
                }
            </Grid>
        </Popup>
    )
}
